module.exports = __webpack_public_path__ + "img/section2_pic1@2x.1adb76e5.png";